import { apiLogout } from "scripts/api/auth";
import { Toast } from "../components/toast";

/**
 * Выход пользователя из аккаунта
 */
export const initLogout = () => {
    const userLogoutBtn = document.getElementById('userLogoutBtn');

    if (!(userLogoutBtn instanceof HTMLButtonElement)){
        throw new Error('Ошибка! Кнопка выхода пользователя из аккаунта не найдена!');
    }

    userLogoutBtn.addEventListener('click', async () => {
        userLogoutBtn.disabled = true;
        const result = await apiLogout();
        if (result){
            window.location.reload();
        } else {
            Toast.error('logout-error', 'Ошибка! Не удалось выйти из аккаунта, попробуйте еще раз');
            userLogoutBtn.disabled = false;
        }
    });
}